<div class="page-container">
  <div class="content-wrapper">
    <div class="content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
